import React from 'react';
import { Button } from "@/components/ui/button";
import { X, Phone, Mail, Clock, AlertTriangle } from "lucide-react";
import { motion } from "framer-motion";

export default function PackageUnavailablePage() {
    // Check URL params for language
    const urlParams = new URLSearchParams(window.location.search);
    const language = urlParams.get('language') || 'he';
    const isRTL = language === 'he';

    const translations = {
        he: {
            title: "החבילה לא זמינה 😔",
            subtitle: "נראה שהחבילה שחיפשת כבר לא קיימת",
            expired: "פג תוקף ⏰",
            soldOut: "אזלה מהמלאי 🛍️",
            contactTitle: "📞 צרי/צור איתנו קשר – נשמח לעזור!",
            contactSubtitle: "צרו איתנו קשר לחבילות אחרות זמינות",
            phone: "טלפון",
            email: "אימייל",
            hours: "שעות פעילות",
            hoursDetails: "ראשון-חמישי: 09:00-17:00",
            backToSite: "לאתר WiWi",
            newPackages: "חבילות חדשות בקרוב",
            newPackagesDesc: "אנחנו עובדים על חבילות חדשות ומעולות. הירשמו לעדכונים והיו הראשונים לדעת!"
        },
        en: {
            title: "Package Unavailable",
            subtitle: "Sorry, the requested package is no longer available",
            expired: "Package has expired",
            soldOut: "Package is sold out",
            contactTitle: "Contact Information",
            contactSubtitle: "Contact us for other available packages",
            phone: "Phone",
            email: "Email", 
            hours: "Business Hours",
            hoursDetails: "Sunday-Thursday: 09:00-17:00",
            backToSite: "Back to WiWi Website",
            newPackages: "New Packages Coming Soon",
            newPackagesDesc: "We're working on new and amazing packages. Sign up for updates and be the first to know!"
        }
    };

    const t = translations[language];
    const reason = urlParams.get('reason') || 'expired'; // 'expired' or 'sold_out'

    return (
        <div className={`min-h-screen bg-gradient-to-br from-red-50 via-orange-50 to-pink-50 flex items-center justify-center p-4`} dir={isRTL ? 'rtl' : 'ltr'}>
            <motion.div 
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                className="bg-white/90 backdrop-blur-sm rounded-3xl shadow-2xl p-8 md:p-12 max-w-2xl w-full"
            >
                {/* Header */}
                <div className="text-center mb-8">
                    <div className="w-20 h-20 bg-gradient-to-r from-red-500 to-orange-500 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
                        {reason === 'sold_out' ? (
                            <AlertTriangle className="w-10 h-10 text-white" />
                        ) : (
                            <Clock className="w-10 h-10 text-white" />
                        )}
                    </div>
                    
                    <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
                        {t.title}
                    </h1>
                    
                    <p className="text-lg text-gray-600 mb-2">
                        {t.subtitle}
                    </p>
                    
                    {/* <div className="inline-flex items-center gap-2 px-4 py-2 bg-red-100 rounded-full text-red-800 font-medium">
                        {reason === 'sold_out' ? (
                            <>
                                <AlertTriangle className="w-5 h-5" />
                                {t.soldOut}
                            </>
                        ) : (
                            <>
                                <Clock className="w-5 h-5" />
                                {t.expired}
                            </>
                        )}
                    </div> */}
                </div>

                {/* Contact Information */}
                {/* <div className="bg-gradient-to-r from-rose-50 to-pink-50 rounded-2xl p-6 mb-8">
                    <h3 className="text-xl font-bold text-gray-800 mb-2 text-center">
                        {t.contactTitle}
                    </h3>
                    <p className="text-gray-600 text-center mb-6">
                        {t.contactSubtitle}
                    </p>
                    
                    <div className="grid md:grid-cols-3 gap-4 text-center">
                        <div className="bg-white/70 rounded-xl p-4 border border-rose-100">
                            <Phone className="w-8 h-8 text-rose-500 mx-auto mb-2" />
                            <div className="font-medium text-gray-700 mb-1">{t.phone}</div>
                            <div className="text-sm text-gray-600" dir="ltr">053-924-2324</div>
                        </div>
                        
                        <div className="bg-white/70 rounded-xl p-4 border border-rose-100">
                            <Mail className="w-8 h-8 text-rose-500 mx-auto mb-2" />
                            <div className="font-medium text-gray-700 mb-1">{t.email}</div>
                            <div className="text-sm text-gray-600" dir="ltr">hello@wiwi.co.il</div>
                        </div>
                        
                        <div className="bg-white/70 rounded-xl p-4 border border-rose-100">
                            <Clock className="w-8 h-8 text-rose-500 mx-auto mb-2" />
                            <div className="font-medium text-gray-700 mb-1">{t.hours}</div>
                            <div className="text-sm text-gray-600">{t.hoursDetails}</div>
                        </div>
                    </div>
                </div> */}

                {/* New Packages Coming Soon
                <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-2xl p-6 mb-8">
                    <h3 className="text-lg font-bold text-gray-800 mb-2 text-center">
                        {t.newPackages}
                    </h3>
                    <p className="text-gray-600 text-center text-sm">
                        {t.newPackagesDesc}
                    </p>
                </div> */}

                {/* Action Buttons */}
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                    <Button 
                        onClick={() => window.location.href = 'https://wiwi.co.il'}
                        className="bg-gradient-to-r from-rose-500 to-pink-500 hover:from-rose-600 hover:to-pink-600 text-white px-8 py-3 rounded-xl text-lg font-semibold shadow-lg hover:shadow-xl transition-all duration-300"
                    >
                        {t.backToSite}
                    </Button>
                </div>

                {/* Footer note */}
                {/* <div className="text-center mt-8 text-sm text-gray-500">
                    <p>WiWi אישורי הגעה בווטצאפ - סימן שכולם באים!</p>
                </div> */}
            </motion.div>
            
            <footer className="fixed bottom-0 left-0 right-0 bg-white/80 backdrop-blur-sm py-2 text-center border-t border-gray-200">
                <a href="https://wiwi.co.il/%D7%94%D7%A6%D7%94%D7%A8%D7%AA-%D7%A0%D7%92%D7%99%D7%A9%D7%95%D7%AA/" className="text-sm text-black hover:text-gray-700 transition-colors" aria-label="Accessibility Statement">
                    הצהרת נגישות
                </a> | <a href="https://wiwi.co.il/privacy-policy/" className="text-sm text-black hover:text-gray-700 transition-colors" aria-label="Privacy Policy">
                    מדיניות פרטיות
                </a>
            </footer>
        </div>
    );
}